// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc } from '../components/BoundOptionPricingConfig.generated';
import { BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc } from '../components/BoundMaterialLeadTimeConfigFields.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostCodesQueryVariables = Types.Exact<{
  filter: Types.CostCodeFilter;
}>;


export type CostCodesQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, number: string, name: string, version: number, quickbooksCategoryId?: string | null | undefined, quickbooksItemId?: string | null | undefined, intacctApAccountId?: string | null | undefined, excludeFromPurchaseOrders: boolean, changeEventAutoAcceptThresholdInCents?: number | null | undefined, isPriceOnly?: boolean | null | undefined, finishScheduleOrder?: number | null | undefined, division: { __typename?: 'CostDivision', id: string, name: string, number: string, version: number, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }, costSubClassification?: { __typename?: 'CostSubClassificationTypeDetail', code: Types.CostSubClassificationType, name: string } | null | undefined, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType, name: string }, optionPricingConfig?: { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }> }> } | null | undefined, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }> };

export type DeleteCostCodeMutationVariables = Types.Exact<{
  input: Types.DeleteCostCodeInput;
}>;


export type DeleteCostCodeMutation = { __typename?: 'Mutation', deleteCostCode: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type AdminCostCodeFragment = { __typename?: 'CostCode', id: string, number: string, name: string, version: number, quickbooksCategoryId?: string | null | undefined, quickbooksItemId?: string | null | undefined, intacctApAccountId?: string | null | undefined, excludeFromPurchaseOrders: boolean, changeEventAutoAcceptThresholdInCents?: number | null | undefined, isPriceOnly?: boolean | null | undefined, finishScheduleOrder?: number | null | undefined, division: { __typename?: 'CostDivision', id: string, name: string, number: string, version: number, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } }, costSubClassification?: { __typename?: 'CostSubClassificationTypeDetail', code: Types.CostSubClassificationType, name: string } | null | undefined, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType, name: string }, optionPricingConfig?: { __typename?: 'OptionPricingConfig', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'OptionPricingConfigVariant', id: string, preCutoffDesiredMarginInBasisPoints: number, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents?: number | null | undefined, minimumPriceInCents?: number | null | undefined, reasonNote?: string | null | undefined, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }> }> } | null | undefined, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined };

export type AdminCostDivisionFragment = { __typename?: 'CostDivision', id: string, name: string, number: string, version: number, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string } };

export const AdminCostDivisionFragmentDoc = gql`
    fragment AdminCostDivision on CostDivision {
  id
  name
  number
  version
  stage {
    code
    name
  }
}
    `;
export const AdminCostCodeFragmentDoc = gql`
    fragment AdminCostCode on CostCode {
  id
  number
  name
  version
  division {
    ...AdminCostDivision
  }
  quickbooksCategoryId
  quickbooksItemId
  intacctApAccountId
  excludeFromPurchaseOrders
  changeEventAutoAcceptThresholdInCents
  isPriceOnly
  costSubClassification {
    code
    name
  }
  costClassification {
    code
    name
  }
  optionPricingConfig {
    ...BoundOptionPricingConfigFields_OptionPricingConfig
  }
  materialLeadTimeConfig {
    ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
  }
  finishScheduleOrder
}
    ${AdminCostDivisionFragmentDoc}
${BoundOptionPricingConfigFields_OptionPricingConfigFragmentDoc}
${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;
export const CostCodesDocument = gql`
    query CostCodes($filter: CostCodeFilter!) {
  costCodes(filter: $filter) {
    ...AdminCostCode
  }
}
    ${AdminCostCodeFragmentDoc}`;

/**
 * __useCostCodesQuery__
 *
 * To run a query within a React component, call `useCostCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCodesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostCodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CostCodesQuery, CostCodesQueryVariables> & ({ variables: CostCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostCodesQuery, CostCodesQueryVariables>(CostCodesDocument, options);
      }
export function useCostCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostCodesQuery, CostCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostCodesQuery, CostCodesQueryVariables>(CostCodesDocument, options);
        }
export function useCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCodesQuery, CostCodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostCodesQuery, CostCodesQueryVariables>(CostCodesDocument, options);
        }
export type CostCodesQueryHookResult = ReturnType<typeof useCostCodesQuery>;
export type CostCodesLazyQueryHookResult = ReturnType<typeof useCostCodesLazyQuery>;
export type CostCodesSuspenseQueryHookResult = ReturnType<typeof useCostCodesSuspenseQuery>;
export type CostCodesQueryResult = Apollo.QueryResult<CostCodesQuery, CostCodesQueryVariables>;
export const DeleteCostCodeDocument = gql`
    mutation DeleteCostCode($input: DeleteCostCodeInput!) {
  deleteCostCode(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteCostCodeMutationFn = Apollo.MutationFunction<DeleteCostCodeMutation, DeleteCostCodeMutationVariables>;

/**
 * __useDeleteCostCodeMutation__
 *
 * To run a mutation, you first call `useDeleteCostCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCostCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCostCodeMutation, { data, loading, error }] = useDeleteCostCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCostCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCostCodeMutation, DeleteCostCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCostCodeMutation, DeleteCostCodeMutationVariables>(DeleteCostCodeDocument, options);
      }
export type DeleteCostCodeMutationHookResult = ReturnType<typeof useDeleteCostCodeMutation>;
export type DeleteCostCodeMutationResult = Apollo.MutationResult<DeleteCostCodeMutation>;
export type DeleteCostCodeMutationOptions = Apollo.BaseMutationOptions<DeleteCostCodeMutation, DeleteCostCodeMutationVariables>;